import axios from "axios";
import staticCaseStudies from "@/data/caseStudies";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
let promise = null;

function fromApi(c) {
  return {
    slug: c.slug,
    company: c.company,
    industry: c.industry,
    headline: c.headline,
    excerpt: c.excerpt || "",
    image: c.image || null,
    metric: c.metric || "",
    metricLabel: c.metric_label || "",
    published: c.published !== false,
    subtitle: c.subtitle || "",
    heroImage: c.hero_image || c.image || null,
    facts: c.facts || [],
    quote: {
      text: c.quote_text || "",
      author: c.quote_author || "",
      role: c.quote_role || "",
      avatar: c.quote_avatar || null,
    },
    challenge: c.challenge || [],
    solution: c.solution || [],
    results: c.results || [],
  };
}

export async function fetchCaseStudies() {
  if (cache) return cache;
  if (promise) return promise;
  promise = (async () => {
    try {
      const { data } = await axios.get(`${API}/case-studies`, { timeout: 8000 });
      if (Array.isArray(data)) {
        // Trust API — even an empty response is authoritative (admin may
        // have cleared all case studies). Only fall back on network error.
        cache = data.map(fromApi);
        return cache;
      }
    } catch (e) {
      console.warn("Case studies API unreachable — using static fallback:", e?.message);
    }
    cache = staticCaseStudies.map((c) => ({ ...c, published: c.published !== false }));
    return cache;
  })();
  return promise;
}

export async function fetchCaseStudy(slug) {
  try {
    const { data } = await axios.get(`${API}/case-studies/${slug}`, { timeout: 8000 });
    if (data && data.slug) return fromApi(data);
  } catch (e) {
    // ignore
  }
  return staticCaseStudies.find((c) => c.slug === slug) || null;
}
